module.exports = __webpack_public_path__ + "img/case-logo-30.bbb1931f.png";